import { actionClient } from '@/api'


// actions
const actions = {
  async document({ commit, dispatch, state }, query) {
    const data = await actionClient.get('member/personal/express', { query })
    return data
  },
}



export default {
  namespaced: true,
  actions,
}
